var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small", "label-width": "120px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "优惠券状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请选择优惠券状态",
                            clearable: "",
                            filterable: "",
                          },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.sendStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "sendStatus", $$v)
                            },
                            expression: "listPram.sendStatus",
                          },
                        },
                        _vm._l(_vm.sendStatusList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { value: item.id, label: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "优惠券ID" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入优惠券ID",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.couponId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "couponId", $$v)
                            },
                            expression: "listPram.couponId",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "归属小程序" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请选择归属小程序",
                            clearable: "",
                            filterable: "",
                          },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.customerId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "customerId", $$v)
                            },
                            expression: "listPram.customerId",
                          },
                        },
                        _vm._l(_vm.companyList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { value: item.id, label: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponId",
                  label: "优惠券ID",
                  "min-width": "90",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponName",
                  label: "优惠券名称",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.checkPermi(["admin:coupon:detail"])
                          ? _c(
                              "span",
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "link",
                                    attrs: {
                                      to:
                                        "/marketing/coupon/detail/" +
                                        scope.row.couponId,
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.couponName))]
                                ),
                              ],
                              1
                            )
                          : _c("span", [
                              _vm._v(
                                "\n                       " +
                                  _vm._s(scope.row.couponName) +
                                  "\n                    "
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "issuanceQuantity",
                  label: "发放数量",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("div", {}, [
                        _c("div", [
                          _vm._v(
                            _vm._s(scope.row.issuanceQuantity) +
                              _vm._s(
                                "【成功：" +
                                  scope.row.successCount +
                                  "；失败：" +
                                  scope.row.failCount +
                                  "】"
                              )
                          ),
                        ]),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "unusedCount",
                  label: "未使用数量",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sendStatusDesc",
                  label: "发放状态",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "miniProgram",
                  label: "归属小程序",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userSource",
                  label: "发放客户类型",
                  "min-width": "120",
                  formatter: _vm.userSourceFormat,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "issuanceTime",
                  label: "发放时间",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "validityStart",
                  label: "有效期-开始",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "validityEnd",
                  label: "有效期-结束",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "validityDays",
                  label: "有效期天数",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.validityType === 1
                          ? _c("span", [
                              _vm._v(
                                "\n                      领取后" +
                                  _vm._s(scope.row.validityDays) +
                                  "天\n                    "
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(scope.row.validityDays) +
                                  "\n                    "
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "100", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:coupon:issuance:detail"],
                                expression: "['admin:coupon:issuance:detail']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openRecord(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("明细")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("OpenDetail", { ref: "OpenDetailRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }